export const URL_BASE_API = process.env.REACT_APP_BACKEND_API
export const URL_BASE_API_V2 = process.env.REACT_APP_BACKEND_API_V2
export const URL_BASE_API_V3 = process.env.REACT_APP_BACKEND_API_V3
